import { useQuery } from '@tanstack/react-query'
import {
	type GetMMDataOverviewParams,
	httpGetMMDataOverview
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const MM_DATA_OVERVIEW_QUERY_KEY = 'mm-data-overview'

export const useGetMMDataOverview = (params: GetMMDataOverviewParams = {}) =>
	useQuery({
		queryKey: [MM_DATA_OVERVIEW_QUERY_KEY, params],
		queryFn: () => httpGetMMDataOverview(params)
	})
